// src/pages/ContactUs.js
import React from 'react';
import ContactSection from '../sections/Contact/ContactSection';
import ContactBanner from '../banners/Contact-Banner/ContactBanner';
import Header from '../components/Header/Header';
const ContactUs = () => {
  return (
    <>
      <Header />
      <ContactBanner />
      <ContactSection />
    </>
  );
};

export default ContactUs;
